import React from 'react';
import { isCMD } from 'utils/helpers';
import { FIELD_EDITABLE_ATTR } from 'client/components/common/BuildingBlocks/Fields/constants';

const isForbiddenTarget = event => {
	const { nodeName, contentEditable } = event.target;
	const forbiddenNodes = ['INPUT', 'TEXTAREA', 'SELECT'];
	const isContentEditable = contentEditable === 'true';

	return isContentEditable || (forbiddenNodes.includes(nodeName) && event.target.hasAttribute(FIELD_EDITABLE_ATTR));
};

const keydown = 'keydown';
const keyup = 'keyup';

export type EventExtraData = {
	command: boolean;
	shift: KeyboardEvent['shiftKey'];
	code: KeyboardEvent['code'];
	alt: KeyboardEvent['altKey'];
};

type Props = {
	onKeyDown: (event: KeyboardEvent, data: EventExtraData) => void;
	onKeyUp: (event: KeyboardEvent, data: EventExtraData) => void;
};

class KeyboardListener extends React.PureComponent<Props> {
	componentDidMount() {
		document.addEventListener(keydown, this.onKeyDown);
		document.addEventListener(keyup, this.onKeyUp);
	}

	componentWillUnmount() {
		document.removeEventListener(keydown, this.onKeyDown);
		document.removeEventListener(keyup, this.onKeyUp);
	}

	getEventData = (event: KeyboardEvent): EventExtraData => {
		return {
			command: isCMD(event),
			shift: event.shiftKey,
			code: event.code,
			alt: event.altKey,
		};
	};

	onKeyUp = (event: KeyboardEvent) => {
		if (isForbiddenTarget(event)) {
			return;
		}

		this.props.onKeyUp(event, this.getEventData(event));
	};

	onKeyDown = (event: KeyboardEvent) => {
		if (isForbiddenTarget(event)) {
			return;
		}

		this.props.onKeyDown(event, this.getEventData(event));
	};

	render() {
		return null;
	}
}

export default KeyboardListener;
